const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  roles: (state) => state.user.roles,
  roles_menu: (state) => state.user.roles_menu,
  roles_sass_menu: (state) => state.user.roles_sass_menu,
  but: (state) => state.user.but,
  natural: (state) => state.user.natural,
  permission_routes: (state) => state.permission.routes,
  updatetable: (state) => state.tagsView.updatetable,
  updateswitch: (state) => state.tagsView.updateswitch,
};
export default getters;
